import type IManageCustomerMessages from '.';

const manageCustomerMessages: IManageCustomerMessages = {
	masterOrderGuides: 'Master Order Guides',
	manageCustomers: 'Manage Customers',
	newCustomer: 'New Customer',
	customers: 'Customers',
	name: 'Name',
	nationalId: 'National Id',
	locationCount: 'Location Count',
};

export default manageCustomerMessages;
